import { t } from 'ttag';

import NModal from '@ui/Modal';
import { Button } from '@ui/Button';
import Title from '@ui/Title';

// styles
import s from './AlreadyComplain.sss';

// types
type AlreadyComplainProps = {
  isOpen: boolean;
  onClose: (event: (React.MouseEvent | React.KeyboardEvent)) => void,
  username: string
};

export const AlreadyComplain: React.FC<AlreadyComplainProps> = ({
  isOpen,
  onClose,
  username,
}) => (
  <NModal isOpen={isOpen} onRequestClose={onClose}>
    <div className={s.root}>
      <Title type="h4" className={s.title}>{t`Дякуємо, що розповіли про ситуацію!`}</Title>

      <p className={s.paragraph}>
        {t`Ви вже помідомили про порушення правил користувачем`}
        {' '}
        {username}
        .
        {t`Звернення прийнято в роботу`}
        <br />
      </p>

      <Button
        type="submit"
        className={s.button}
        onClick={onClose}
      >
        {t`Добре`}
      </Button>
    </div>
  </NModal>
);

export default AlreadyComplain;
